import Honeybadger from "@honeybadger-io/js";

import { getConfig } from "./services/config";

let initialized = false;

window.Honeybadger = Honeybadger;

export function initialize() {
  if (initialized || !getConfig("honeybadger")?.apiKey) {
    return;
  }
  Honeybadger.configure(getConfig("honeybadger"));
  Honeybadger.setContext({
    userId: window.__preloadState.currentUser?.id,
  });

  initialized = true;
}

function honeyBadgerConfigured() {
  if (!initialized) {
    initialize();
  }
  return initialized;
}

/**
 * Adds user or similar to context
 */
export function setErrorContext(context) {
  if (honeyBadgerConfigured()) {
    Honeybadger.setContext(context);
  }
}

export function sendError(error, params = undefined) {
  if (honeyBadgerConfigured()) {
    try {
      Honeybadger.notify(
        error || "Unknown error",
        params ? { details: params } : undefined
      );
    } catch (err) {
      console.error("Error processing error", err, "original:", error, params);
      // Honeybadger.notify(err);
    }
  } else {
    // On dev and test we just show this error in the console
    console.error(error, params);
  }
}
